import Raven from 'raven-js';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { H4 } from 'foundations-components/transitional/components/H4';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import PracticalExerciseWrapper from './PracticalExerciseWrapper';
import PracticalExerciseRetryButtonContainer from './PracticalExerciseRetryButtonContainer';
import { useLoadPracticalExerciseSurvey, useNavigateToExercise } from '../practicalExerciseHooks';
import { usePracticalExercisePortalId } from '../practicalExerciseQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InProgressPracticalExercise = ({
  exercise,
  advanceToNextContent,
  contentId,
  lessonId,
  trackId,
  exerciseLocation,
  language,
  onResumeExercise
}) => {
  const {
    getOrCreatePortal,
    portalIdLoading,
    isSimulationExercise,
    isSimulationGateLoading
  } = usePracticalExercisePortalId(Number(contentId), trackId);
  useLoadPracticalExerciseSurvey({
    skip: !isSimulationExercise
  });
  const {
    navigateToExercise,
    loading
  } = useNavigateToExercise({
    contentId,
    lessonId,
    trackId,
    language,
    exerciseLocation,
    onClick: onResumeExercise
  });
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "in-progress-practical-exercise",
    children: /*#__PURE__*/_jsx(PracticalExerciseWrapper, {
      buttons: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          marginInlineEnd: "300",
          children: /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, {
            contentId: contentId,
            "data-test-id": "practical-exercise-retry-button",
            lessonId: lessonId,
            trackId: trackId,
            use: "tertiary-light"
          })
        }), /*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": "practical-exercise-resume-button",
          external: true,
          loading: loading || portalIdLoading || isSimulationGateLoading,
          onClick: () => {
            if (!isSimulationExercise) {
              navigateToExercise().catch(Raven.captureException.bind(Raven));
            } else {
              var _getOrCreatePortal;
              (_getOrCreatePortal = getOrCreatePortal()) === null || _getOrCreatePortal === void 0 || _getOrCreatePortal.then(response => {
                var _response$data;
                navigateToExercise(response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.createPortal) === null || _response$data === void 0 ? void 0 : _response$data.portalId).catch(Raven.captureException.bind(Raven));
              }).catch(Raven.captureException.bind(Raven));
            }
          },
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.external.started.exerciseLink"
          })
        }), /*#__PURE__*/_jsx(Button, {
          marginInlineStart: "300",
          onClick: advanceToNextContent,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.next"
          })
        })]
      }),
      illustrationName: "note-widget",
      children: /*#__PURE__*/_jsxs(View, {
        borderInlineStartColor: "border-core-subtle",
        borderInlineStartStyle: "solid",
        borderInlineStartWidth: "100",
        marginBlock: "1000",
        minBlockSize: "300px",
        paddingInlineStart: "1000",
        children: [/*#__PURE__*/_jsx(H4, {
          children: exercise.name
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.practicalExercise.instructions.inProgress.top.manual"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.instructions.inProgress.top.certified"
          })
        }), isSimulationExercise && /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.simulation.playgroundWillOpen"
          }), ' ', /*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.practicalExercise.simulation.progressReset"
            })
          })]
        })]
      })
    })
  });
};
export default InProgressPracticalExercise;